import HttpV2 from './HttpV2';

class CampaignAdjustmentServiceV2 {
  static async createCampaignAdjustment(campaignId, payload) {
    return HttpV2.post(`campaign-adjustments/${campaignId}`, payload);
  }

  static async getCampaignAdjustments(campaignId) {
    return HttpV2.get(`campaign-adjustments/${campaignId}`);
  }

  static async deleteCampaignAdjustments(campaignId) {
    return HttpV2.delete(`campaign-adjustments/${campaignId}`);
  }
}

export default CampaignAdjustmentServiceV2;
